/* biome-ignore-file */
import React, { useEffect, useRef, useState, useCallback, use } from "react";
import * as url from "../../helpers/url_helper";
import config, { api } from "../../config";
import { Spinner, ButtonGroup } from "reactstrap";
import 'regenerator-runtime/runtime';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import favicon from '../../assets/images/about.jpg';
import {
  Button,
  UncontrolledTooltip,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  ModalHeader,

} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import Picker from "emoji-picker-react";
import { after, before, isEmpty, map } from "lodash";
import { EventSourcePolyfill } from 'event-source-polyfill';


//Import Icons
import FeatherIcon from "feather-icons-react";
import PersonalInfo from "./PersonalInfo";

import { chatContactData } from "../../common/data";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
  getDirectContact as onGetDirectContact,
  // getMessages,
  getChannels as onGetChannels,
  addMessage as onAddMessage,
  deleteMessage as onDeleteMessage,
  Bot_Chat_History,
  Bot_Ask_Message,
  Bot_Chat_History_Append,
  Bot_Chat_Cancel,
  Bot_Ask_Message_with_data_base,
  Bot_Thread_Create,
  Bot_Thread_Create_Clear_Context,
  Bot_Ask_Message_with_file,
  Bot_Ask_Message_with_file_and_database,
  Bot_Chat_History_mongo,
  Bot_Chat_History_Append_mongo,
  Bot_Speech_Text_file,
  Delete_Chat_Message,
  THUMB_UP_MESSAGE,
  bot_details,
} from "../../slices/thunks";

import avatar2 from "../../assets/images/users/avatar-2.jpg";
import userDummayImage from "../../assets/images/users/user-dummy-img.jpg";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { createSelector } from "reselect";
import moment from "moment";
import MarkdownRenderer from "../../utility/MarkDownRenderer";
import { set_Fav_Prompt_Question_reset } from "../../slices/Favourite_Prompt/reducer";
import { store } from "../..";
import TypingLoader_cust from "./TypingLoader_cust";
import Mark_Favourite_modal from "../../Components/Common/CustomModal/Mark_Favourite_modal";
import { Remove_Extra_Text } from "../../utility/Remove_Extra_text";
import Chat_Sql_Modal from "../../Components/Common/CustomModal/Chat_Sql_Modal";
import Chat_File_Upload_Item from "./Chat_File_Upload_Item";
import { setFiles } from "@testing-library/user-event/dist/cjs/utils/index.js";
import Chat_View_Item from "./Chat_View_Item";
import {
  convertGmtToUserLocal,
  convertISODateToUserLocal,
} from "../../slices/layouts/utils";
import {
  fetch_chat_history_success,
  reset_chat_history,
  set_typing_loader,
} from "../../slices/Chat_Cust/reducer";
import "./MarkDown.css";
import HandleSpeech_Button from "./HandleSpeech_Button";
import { Loader } from "feather-icons-react/build/IconComponents";
import { AreaCharts, BarChart, BarCharWithMarkers, LineChart,MultiAxisLineChart, PieChart, StackedBarChart , Range, RangeBarChart, LineBarChart, SimpleDonutChart } from "../Charts/ChartsJs/ChartsJs";
import Sql_Preview_modal from "../../Components/Common/CustomModal/Sql_Preview_modal";
import ClearContext from "../../Components/Common/ClearContext";
import GoogleMark from "../../Components/Common/GoogleMark";
import GoogleDistance from "../../Components/Common/GoogleDistance";
import { vector } from "echarts";
import Mongo_DB_Query_modal from "../../Components/Common/CustomModal/Mongo_DB_Query_modal";
import Thumb_Down_Reason_Modal from "../../Components/Common/CustomModal/Thumb_Down_Reason_Modal";
import Query_Explanation from "../../Components/Common/CustomModal/Query_Explanation";
import { get_Models } from "../../helpers/fakebackend_helper";
import FilePreview from "./FilePreview";
import ScatterChart from "../DragDrop/Charts/ScatterChart";
import HorizontalBarChart from "../DragDrop/Charts/HorizontalBarChart";
import { useStateManager } from "react-select";
import Chat_Tool from "./Chat_Tool";
import ImageModal from "./ImageModal";
import PythonEditor_Modal from "../../Components/Common/PythonEditor_Modal";
const Chat = () => {
  const [likeMessageVisible, setLikeMessageVisible] = useState(false);
 const [web_search_toggle, setweb_search_toggle] = useState(false)
 const [_streaming_message_time, set_streaming_message_time] = useState(null)
 const textareaRef = useRef(null);
 const [image_urls, setimage_urls] = useState([])

  const [show_sql_of_prompt, setshow_sql_of_prompt] = useState({
    show: false,
    query: "",
  });
  
  const [files, setfiles] = useState([]);
  const { User_Role } = useSelector((state)=>state.BotDetails.Bot_Details)
  const {  Inserted_Values,Insertion_Query,insert_table,searchable_column } = useSelector((state)=>state.Bot_List)

  const hiddenFileInput = useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
const handleChange = async (event) => {
  const uploadedFiles = Array.from(event.target.files); // convert FileList to Array

  // filter only image files
  handleFiles(uploadedFiles); // if you still want to handle all uploaded files
  const imageFiles = uploadedFiles.filter(file => file.type.startsWith("image/"));

  hiddenFileInput.current.value = "";

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result); // result includes data:<mimetype>;base64,...
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  try {
    // Convert only images
    const base64Array = await Promise.all(imageFiles.map(convertToBase64));
    setimage_urls(base64Array); // Store only image base64 in state
  } catch (err) {
    console.error("Error converting files to Base64:", err);
  }
};


const handleFiles = (newFiles) => {
  const totalAllowed = config.general_config.chat_file_upload_limit;
  const currentFiles = [...files];
  const remainingSlots = totalAllowed - currentFiles.length;

  if (remainingSlots <= 0) return; // already at max limit

  const filesToAdd = newFiles.slice(0, remainingSlots); // limit to remaining slots
  setfiles([...currentFiles, ...filesToAdd]);
};

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const userChatShow = useRef();
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const dispatch = useDispatch();
  const [isInfoDetails, setIsInfoDetails] = useState(false);
  const [Chat_Box_Username, setChat_Box_Username] = useState("Lisa Parker");
  const [Chat_Box_Image, setChat_Box_Image] = useState(avatar2);
  const [currentRoomId, setCurrentRoomId] = useState(1);
  const messageBox = useRef(null);
  const [curMessage, setcurMessage] = useState("");
  const [search_Menu, setsearch_Menu] = useState(false);
  const [settings_Menu, setsettings_Menu] = useState(false);
  const [reply, setreply] = useState("");
  const [emojiPicker, setemojiPicker] = useState(false);
  const [visualization_modal, setvisualization_modal] = useState(false)
  const [visualization_modal_component, setvisualization_modal_component] = useState(null)
  const [currentUser, setCurrentUser] = useState({
    name: "Bot",
    isActive: true,
  });

  const selectLayoutState = (state) => state.Chat;
  const chatProperties = createSelector(selectLayoutState, (state) => ({
    chats: state.chats,
    messages: state.messages,
    channels: state.channels,
  }));

  // Inside your component
  const { chats, messages, channels } = useSelector(chatProperties);
  //Toggle Chat Box Menus
  const toggleSearch = () => {
    setsearch_Menu(!search_Menu);
  };

  //Info details offcanvas
  const toggleInfo = () => {
    setIsInfoDetails(!isInfoDetails);
  };

  const toggleSettings = () => {
    setsettings_Menu(!settings_Menu);
  };

  // useEffect(() => {

  //   dispatch(onGetDirectContact());
  //   dispatch(onGetChannels());

  //   dispatch(getMessages());

  // }, [dispatch, currentRoomId]);

  //Use For Chat Box
  const userChatOpen = (id, name, status, roomId, image) => {
    setChat_Box_Username(name);
    setCurrentRoomId(roomId);
    setChat_Box_Image(image);
    // dispatch(getMessages(roomId));
    if (window.innerWidth < 892) {
      userChatShow.current.classList.add("user-chat-show");
    }
  };

  const backToUserChat = () => {
    userChatShow.current.classList.remove("user-chat-show");
  };

  const addMessage = (roomId, sender) => {
    const message = {
      id: Math.floor(Math.random() * 100),
      roomId,
      sender,
      message: curMessage,
      createdAt: new Date(),
    };
    setcurMessage("");
    dispatch(onAddMessage(message));
  };

  const scrollToBottom = useCallback(() => {
    // console.log("scroll")
    setTimeout(() => {
      if (messageBox) {
        messageBox.scrollTop = messageBox.scrollHeight + 1000;
      }
    }, 500); // Delay scroll to allow Google Maps to render properly
  }, [messageBox]);

  useEffect(() => {
    if (!isEmpty(messages)) scrollToBottom();
  }, [messages, scrollToBottom]);


  

  const onKeyPress = (e) => {
    const { key, value } = e;

    if (e.key === "Enter" && e.shiftKey) {
      return
    } 
    
    if (key === "Enter") {
      e.preventDefault();
      if (Boolean(!ask_bot_loading)) {
        onAsk_message(asked_message);

        resetTextareaHeight();
      }
    }
  };

  // increaseing height testing
  // const adjustHeight = (e) => {

  //   const textarea = e.target;

  //   textarea.style.height = 'auto';

  //   const newHeight = Math.min(textarea.scrollHeight, 150);
  //   textarea.style.height = `${newHeight}px`;

  //   textarea.style.top = `-${newHeight}px`;
  // };
  // const resetTextareaHeight = () => {

  //   const textarea = document.getElementById("chat-input");    
  //   // Reset height and top position to initial state
  //   textarea.style.height = 'auto';
  //   textarea.style.top = '-36px';  // Reset top to 0
  // };
  const adjustHeight = (e) => {
   
    const textarea = e.target;

    textarea.style.height = 'auto';

    const newHeight = Math.min(textarea.scrollHeight, 150);
    textarea.style.height = `${newHeight}px`;

    textarea.style.top = `-${newHeight}px`;
  };
  const resetTextareaHeight = () => {
    // console.log("resetTextareaHeight");
    
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.top = "-36px"; // Reset top position
      // console.log(textareaRef.current);
    }
  };

  // //Search Message
  // const searchMessages = () => {
  //   var searchInput, searchFilter, searchUL, searchLI, a, i, txtValue;
  //   searchInput = document.getElementById("searchMessage");
  //   searchFilter = searchInput.value.toUpperCase();
  //   searchUL = document.getElementById("users-conversation");
  //   searchLI = searchUL.getElementsByTagName("li");
  //   Array.prototype.forEach.call(searchLI, function (search) {
  //     a = search.getElementsByTagName("p")[0]
  //       ? search.getElementsByTagName("p")[0]
  //       : "";
  //     txtValue =
  //       a.textContent || a.innerText ? a.textContent || a.innerText : "";
  //     if (txtValue.toUpperCase().indexOf(searchFilter) > -1) {
  //       search.style.display = "";
  //     } else {
  //       search.style.display = "none";
  //     }
  //   });
  // };

  // Copy Message
  const handleCkick = (ele) => {
    const copy = ele
      .closest(".chat-list")
      .querySelector(".ctext-content").innerText;
    navigator.clipboard.writeText(copy);

    document.getElementById("copyClipBoard").style.display = "block";
    setTimeout(() => {
      document.getElementById("copyClipBoard").style.display = "none";
    }, 2000);
  };



  // emoji
  const [emojiArray, setemojiArray] = useState("");

  const onEmojiClick = (event, emojiObject) => {
    setemojiArray([...emojiArray, emojiObject.emoji]);
    let emoji = [...emojiArray, emojiObject.emoji].join(" ");
    setcurMessage(curMessage + event.emoji);
  };
  const { selectedthread } = useSelector((state) => state.Threads);

  document.title = "Chat";

  const [run_id, setrun_id] = useState(null);
  const [typingloader, settypingloader] = useState(false);

  const {
    chat_history,
    loading,
    ask_bot_loading,
    show_sql_popup_button,
    show_sql_popup_query,
    typing_loader,
    ask_bot_response,
    streaming_message_time,
    transcription_text,
    transcriptions_loading
  } = useSelector((state) => state.Chat_History);
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const { Prompt_Question, edit_mode } = useSelector(
    (state) => state.Favourite_Prompt
  );

  const [current_message_list, setcurrent_message_list] = useState([]);
  const [asked_message, setasked_message] = useState(null);
  const [streaming_message, setstreaming_message] = useState("");
  const [previousScrollHeight, setpreviousScrollHeight] = useState(null);
  const [event_state, setevent_state] = useState("")
  const [do_not_remove_previous_message, setdo_not_remove_previous_message] =
    useState(false);
  const scrollableNodeRef = useRef();


  useEffect(() => {  
    dispatch(reset_chat_history())
  }, [selectedthread])
  

  //Typing loader.
  useEffect(() => {
    settypingloader(typing_loader);
    scrollToBottom()
  }, [typing_loader]);


    //Typing loader.
  useEffect(() => {
    setTimeout(scroll_chat_toBottom,1000)
    setTimeout(scrollToBottom,1000)
  }, [streaming_message, set_streaming_message_time]);

  useEffect(() => {
    dispatch(set_typing_loader(typingloader));
  }, [typingloader, settypingloader]);

  // Intialize Event Source for Chat .

  function isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}


  useEffect(() => {
    if(ask_bot_loading)
    {if (selectedthread?.thread_id) {
      const baseURL =
        window.location.hostname === "localhost"
          ? api.API_URL_LOCAL_HOST
          : api.API_URL;
      const eventSource = new EventSourcePolyfill(
        `${baseURL}${url.chat_reponse}/${selectedthread?.thread_id}`,
        {

          heartbeatTimeout: 120000,
          withCredentials: false,
      }
      );

      eventSource.onmessage = (event) => {
        
        if(isValidJSON(event.data)){
        const { message, RunID } = JSON.parse(event.data);
        if (message === "") {
          // setstreaming_message("");
        }

        if (message.length > 0 ) {
          setstreaming_message(message);
          if(message.trim().length !== 0){
          settypingloader(false);

          }
        }

        if (RunID) {
          setrun_id(RunID);
          settypingloader(false);
        }
      }
      };

      eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
      };

      return () => {
        eventSource.close();
      };
    }}
  }, [selectedthread, ask_bot_loading]);



  useEffect(() => {
    if (selectedthread?.thread_id && ask_bot_loading) {
      const baseURL =
        window.location.hostname === "localhost"
          ? api.API_URL_LOCAL_HOST
          : api.API_URL;
      const eventSource = new EventSourcePolyfill(
        `${baseURL}${url.event_stream}/${selectedthread?.thread_id}`,
        {

          heartbeatTimeout: 120000,
          withCredentials: false,
      }
      );

      eventSource.onmessage = (event) => {
        
        if(isValidJSON(event.data)){
        const { message, RunID } = JSON.parse(event.data);
        if (message === "") {
          // setstreaming_message("");
        }

        if (message.length > 0 ) {
          setevent_state(message);
        
        }

     
      }
      };

      eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
        setevent_state("");
      };

      return () => {
        eventSource.close();
      };
    }
  }, [selectedthread , ask_bot_loading]);


  useEffect(() => {
    
    if(Inserted_Values?.length > 0 && searchable_column && insert_table  ){
      let search_value = Inserted_Values.map((ele)=>{
          return ele[`${searchable_column}`]
      })

      search_value = [...new Set(search_value)];

      setasked_message(`Search for ${searchable_column} ${search_value.join(' , ')} in ${insert_table} table in database .`)
      onAsk_message(`Search for ${searchable_column} ${search_value.join(' , ')} in ${insert_table} table in database .`)
    }

  }, [searchable_column , insert_table , Inserted_Values])
  





  // Get Chat history
  useEffect(() => {
 
    if (selectedthread?.thread_id && !do_not_remove_previous_message) {
      dispatch(
        Bot_Chat_History_mongo({
          session_id: selectedthread?.thread_id,
          limit: config.general_config.chat_limit,
        })
      );
      // dispatch(Bot_Chat_History(selectedthread?.thread_id))
      setstreaming_message("");
      setcurrent_message_list([]);
    }

    setdo_not_remove_previous_message(false);
  }, [selectedthread]);


  useEffect(() => {
      if(!ask_bot_loading){
        setevent_state("")
        let temp = current_message_list[current_message_list.length-1]
        let current_message_copy = current_message_list
        if(temp){
          temp['sequence_id'] = ask_bot_response?.user_sequence_id
          current_message_copy[current_message_list.length-1] = temp
          setcurrent_message_list(current_message_copy)

        }
      }

  
  }, [ask_bot_loading])
  

 

  // Ask favorite Bot.
  useEffect(() => {
    // Only run when it is not in edit mode .

    if (Prompt_Question && !edit_mode && Boolean(!ask_bot_loading)) {
      onAsk_message(Prompt_Question);
      dispatch(set_Fav_Prompt_Question_reset());

      // If edit mode is true also do not delete the message .
    } else if (!edit_mode) {
      dispatch(set_Fav_Prompt_Question_reset());
    }
  }, [Prompt_Question]);

  // Reatil Scroll Height
  useEffect(() => {
    if (scrollableNodeRef.current) {
      const newScrollHeight =
        scrollableNodeRef.current.scrollHeight - previousScrollHeight;
      scrollableNodeRef.current.scrollTop = newScrollHeight - 50;
    }
  }, [chat_history, previousScrollHeight]);

  const downloadText = (content) => {
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "CHAT.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const AppendMessagesonTop = () => {
   
    
    setpreviousScrollHeight(scrollableNodeRef.current.scrollHeight);

    // Get Directly From store beacuse i am have setting this funtion in useEffect and useEffct do not have this value

    const { chat_history } = store.getState().Chat_History;

    if (chat_history[0]?.sequence_id) {
      dispatch(
        Bot_Chat_History_Append_mongo({
          session_id: store.getState().Threads.selectedthread?.thread_id,
          limit: config.general_config.chat_limit,
          before: chat_history[0].sequence_id,
        })
      );
    }
  };

  // Scroll Chat to Bottom .
  const scroll_chat_toBottom = () => {
    // console.log("Scroll Chat");
    
    if (scrollableNodeRef.current) {
      scrollableNodeRef.current.scrollTop =
        scrollableNodeRef.current.scrollHeight;
    }
  };

  const onAsk_message = (message) => {
    setstreaming_message("");
    scroll_chat_toBottom();
    if ((!message|| message.trim() === 0) && files.length===0 && !audioURL) {
      return;
    }
     if(!message|| message.trim() === 0){
      message = " "
     }
    settypingloader(true);
    let temp = current_message_list;

    if (streaming_message.trim().length !== 0) {
      temp.push({
        message: streaming_message,
        visualization: ask_bot_response?.visualization,
        query: ask_bot_response?.query,
        dbinsight_tokens:ask_bot_response?.DbInsightTokens,
        distance_map_data: ask_bot_response?.Distance_Map_Data,
        places_map_data: ask_bot_response?.Places_Map_Data,
        formatted_data_for_visualization: ask_bot_response?.formatted_data_for_visualization,
        query_description:ask_bot_response?.query_description,
        role: "assistant",
        timeStamp: new Date(),
        sequence_id:ask_bot_response.bot_sequence_id,
        pandas_code_xml:ask_bot_response?.pandas_code_xml
      });
    }

    temp.push({
      message: message,
      role: "user",
      timeStamp: new Date(),
      sequence_id:null,
      image_urls:image_urls,
      thread_file_inputs:files
    });

    setimage_urls([])
    setfiles([])
    if (BotDetails.Type === "DBLink") {
      dispatch(
        Bot_Ask_Message_with_file_and_database({
          assistant_id: BotDetails.Assets_ID,
          message: message,
          thread_id: selectedthread?.thread_id,
          databaseId: BotDetails.Database_ID,
          model: BotDetails.Model,
          instructions: BotDetails.Bot_Instructions,
          number_of_rows: BotDetails.Max_Record,
          files,
          selectedLanguage,
          bot_id:BotDetails.Bot_ID,
          websearch:web_search_toggle,
          sql_instructions: BotDetails.SQL_Instruction,
          sql_model: BotDetails.Query_Model,
          vector_chunk_count: BotDetails.vector_chunk_count,
          send_sql_to_llm:BotDetails.send_sql_to_llm
        })
      );

      //   dispatch(Bot_Ask_Message_with_data_base({
      //     assistant_id: BotDetails.Assets_ID,
      //     message: message,
      //     thread_id: selectedthread?.thread_id,
      //     databaseId: BotDetails.Database_ID,
      //     model: BotDetails.Model,
      //     instructions: BotDetails.Bot_Instructions,
      //     number_of_rows: BotDetails.Max_Record
      // }))
    } else {
      dispatch(
        Bot_Ask_Message_with_file({
          Bot_ID:BotDetails.Bot_ID.toString(),
          assistant_id: BotDetails.Assets_ID,
          message: message,
          thread_id: selectedthread?.thread_id,
          databaseId: BotDetails.Database_ID,
          model: BotDetails.Model,
          instructions: BotDetails.Bot_Instructions,
          number_of_rows: BotDetails.Max_Record,
          files,
          selectedLanguage,
          websearch:web_search_toggle,
          vector_chunk_count: BotDetails.vector_chunk_count,
          // audioBlob
        })
      );

      //    dispatch(Bot_Ask_Message({
      //      assistant_id: BotDetails.Assets_ID,
      //      message: message,
      //      thread_id: selectedthread?.thread_id,
      //      databaseId: BotDetails.Database_ID,
      //      model: BotDetails.Model,
      //      instructions: BotDetails.Bot_Instructions,
      //      number_of_rows: BotDetails.Max_Record
      //  }))
    }

    setcurrent_message_list(temp);
    setasked_message("");
    setstreaming_message("");
    setfiles([]);

    // setAudioURL(null)
  };

  useEffect(() => {
    const handleScroll = () => {
      if (scrollableNodeRef.current.scrollTop === 0) {
        AppendMessagesonTop();
        // console.log("Scrolled to the top!");
      }
    };

    const scrollableNode = scrollableNodeRef.current;
    if (scrollableNode) {
      scrollableNode.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableNode) {
        scrollableNode.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);


  // Clear the chat History if component is reloaded.

  const reset_chat = () => {
    dispatch(Bot_Thread_Create_Clear_Context(BotDetails.Assets_ID, "reset"));
  };

  const clear_context = () => {
    setdo_not_remove_previous_message(false);
    dispatch(
      Bot_Thread_Create_Clear_Context(selectedthread?.thread_id, "clear_context")
    );
    setstreaming_message("");
    setcurrent_message_list([]);

    document.getElementById("clear_alert").style.display = "block";
    setTimeout(() => {
      document.getElementById("clear_alert").style.display = "none";
    }, 2000);

  };

  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [audioBlob, setaudioBlob] = useState(null)
  const [models_list, setmodels_list] = useState([])
  const [allowed_images, setallowed_images] = useState(false)
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  useEffect(() => {
        get_Models()
        .then((response) => {

          setmodels_list(response);

         
        })
        .catch((error) => {
          console.log(error);
        });
  
 
  }, [])


  useEffect(() => {
console.log("Models List", models_list);
     map(models_list, (model) => {
      if (model.ModelVersion === BotDetails.Model) {
        console.log("Model found:", model);
         map(model.ModelCompatibility, (capability) => {
          console.log("Capability found:", capability);
          if (capability.File_Type === "image" && capability.Compatible ) {
            console.log("Image capability found for model:", model.ModelVersion);
            setallowed_images(true);
          }
          else{
            setallowed_images(false);

          }
      });
    }
  });

  
  }, [BotDetails.Model , models_list])
  
  

  

  // Add Trasscription text to chat box .
  useEffect(() => {
     setasked_message(transcription_text)
  }, [transcription_text])
  async function convertAudioToMono(file){
    try {
      const audioContext = new AudioContext({ sampleRate: 16000 });
      const arrayBuffer = await file.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
      // Create offline context for processing
      const offlineContext = new OfflineAudioContext(1, audioBuffer.length, 16000);
      const source = offlineContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(offlineContext.destination);
      source.start();
  
      // Render audio
      const renderedBuffer = await offlineContext.startRendering();
  
      // Convert to WAV format
      const wavBuffer = createWavBuffer(renderedBuffer);
      return new Blob([wavBuffer], { type: "audio/wav" });
  
    } catch (error) {
      console.error("Error converting audio to mono:", error);
      throw error;
    }
  }
  
  // Helper to create WAV header and buffer
  function createWavBuffer(renderedBuffer) {
    const length = renderedBuffer.length * 2; // 16-bit PCM
    const buffer = new ArrayBuffer(44 + length);
    const view = new DataView(buffer);
  
    // WAV file format constants
    const writeString = (view, offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };
  
    writeString(view, 0, "RIFF"); // ChunkID
    view.setUint32(4, 36 + length, true); // ChunkSize
    writeString(view, 8, "WAVE"); // Format
    writeString(view, 12, "fmt "); // Subchunk1ID
    view.setUint32(16, 16, true); // Subchunk1Size (16 for PCM)
    view.setUint16(20, 1, true); // AudioFormat (1 for PCM)
    view.setUint16(22, 1, true); // NumChannels (1 for mono)
    view.setUint32(24, 16000, true); // SampleRate
    view.setUint32(28, 16000 * 2, true); // ByteRate (SampleRate * NumChannels * BitsPerSample/8)
    view.setUint16(32, 2, true); // BlockAlign (NumChannels * BitsPerSample/8)
    view.setUint16(34, 16, true); // BitsPerSample
    writeString(view, 36, "data"); // Subchunk2ID
    view.setUint32(40, length, true); // Subchunk2Size
  
    // Write PCM samples
    const channelData = renderedBuffer.getChannelData(0); // Mono channel data
    let offset = 44;
    for (let i = 0; i < channelData.length; i++) {
      const sample = Math.max(-1, Math.min(1, channelData[i])); // Clamp to [-1, 1]
      view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
      offset += 2;
    }
  
    return buffer;
  }
  
  function isIOSDevice() {
    return /iPhone|iPad/i.test(navigator.userAgent);
}

  const startRecording = async () => {

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };
      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
        const monoAudioBlob = isIOSDevice ? await convertAudioToMono(audioBlob): audioBlob;
        setaudioBlob(monoAudioBlob) 
        dispatch(Bot_Speech_Text_file({audioBlob:monoAudioBlob }))      
        setAudioURL(URL.createObjectURL(monoAudioBlob));
        audioChunksRef.current = [];
      };
      mediaRecorderRef.current.start();
      setRecording(true);
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  }


  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };



  const {
    transcript,
    listening  } = useSpeechRecognition();


  useEffect(() => {

   setasked_message(transcript)
  }, [listening])


   // When ever a new message is received scroll to bottom .
   useEffect(() => {
    scroll_chat_toBottom();
  }, [asked_message, streaming_message, setstreaming_message , selectedthread ]);
  
  //lang response select
  const [selectedLanguage, setSelectedLanguage] = useState(''); // Default placeholder text
  // biome-ignore lint/style/useSelfClosingElements: <explanation>
  const [selected_language_lable, setselected_language_lable] = useState(<i className="ri-translate-2"></i>)
  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
  };

  const [isActiveWeb, setIsActiveWeb] = useState(false);

  const handleClick_button = () => {
    setIsActiveWeb(!isActiveWeb);
    setweb_search_toggle(!web_search_toggle)
    // setweb_search_toggle(!web_search_toggle)
  };

   // ===========
   const [isActive, setIsActive] = useState(false);
   const floatContentRef = useRef(null);
   const buttonRef = useRef(null);
 
   const handleClick_float = (event) => {
     if (buttonRef.current && buttonRef.current.contains(event.target)) {
       setIsActive((prev) => !prev); // Toggle active class
     } else if (floatContentRef.current && !floatContentRef.current.contains(event.target)) {
       setIsActive(false); // Remove active class when clicking outside
     }
   };
   useEffect(() => {
     window.addEventListener("click", handleClick_float);
     return () => window.removeEventListener("click", handleClick_float);
   }, []);
   // ===================


   const generate_Chart = (visualization, formatted_data_for_visualization) => {
    console.log(visualization, formatted_data_for_visualization, "Visualization");

    // Ensure data is in JSON format
    let data;
    try {
        data = typeof formatted_data_for_visualization === "string" 
            ? JSON.parse(formatted_data_for_visualization) 
            : formatted_data_for_visualization;
    } catch (error) {
        console.error("Invalid JSON format for visualization data:", error);
        return <p>Error: Invalid data format</p>;
    }
   
   if(formatted_data_for_visualization == {} ||  formatted_data_for_visualization == "{}"){
    return " "
   }
    // Render the appropriate chart
    if (visualization === "pie") {
        return <PieChart data_set={data} />;
    }
    if (visualization === "bar") {
        return <BarChart data_set={data} />;
    }
    if (visualization === "line") {
        return <LineChart data_set={data} />;
    }

    if (visualization === "bar_with_stacked") {
        return <StackedBarChart data_set={data} />;
    }

    if (visualization === "bar_with_marker") {
        return <BarCharWithMarkers data_set={data} />;
    }

    if (visualization === "multi_axis_line_chart") {
        return <MultiAxisLineChart data_set={data} />;
    }
    if (visualization === "area_chart") {
        return <AreaCharts data_set={JSON.parse(JSON.stringify(data))} />;
    }
     if (visualization === "range_bar") {
        return <RangeBarChart data_set={JSON.parse(JSON.stringify(data))} />;
    }
    if (visualization === "donut") {
        return <SimpleDonutChart data_set={JSON.parse(JSON.stringify(data))} />;
    }
    if (visualization === "line_column") {
        return <LineBarChart data_set={JSON.parse(JSON.stringify(data))} />;
    }
 
    if (visualization === "scatter") {
        return <ScatterChart  data_set={JSON.parse(JSON.stringify(data))} />;
    }
    if (visualization === "horizontal_bar") {
        return <HorizontalBarChart  data_set={JSON.parse(JSON.stringify(data))} />;
    }

    // Fallback for unsupported visualization types
    // return <p>Unsupported visualization type</p>;
};

const [isFull, setIsFull] = useState(false);

  const handleAddClass = () => {
    setIsFull(true);
  };

const handleRemoveClass = () => {
  setIsFull(false);
};
   


// Default Tabs
    const [activeTab, setactiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };


const [openChartModalKey, setOpenChartModalKey] = useState(null);
const [modal_standard, setmodal_standard] = useState(false);
    const view_full_chart = (key) => {
      setOpenChartModalKey(key); // open only this one
    };

const Delete_Message = (thread_id , sequence_id) =>{
  dispatch(Delete_Chat_Message({ thread_id:thread_id.thread_id , sequence_id }))
}


useEffect(() => {
   setcurrent_message_list([])
   setstreaming_message('')
}, [chat_history])

// temporery tool show hide 
const [isshowTool, setshowTool] = useState(false);
  const toolRef = useRef(null);
  const buttonToolRef = useRef(null);

  const toggleTool = (e) => {
    e.stopPropagation();
    setshowTool((prev) => !prev);
  };
const handleClickOutside = (event) => {
     setshowTool(false);
    };
  useEffect(() => {

    document.addEventListener("click", handleClickOutside);
    if (!isshowTool) return;    
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isshowTool]);

// end

const [isFocused, setIsFocused] = useState(false);

const [selectedImage, setSelectedImage] = useState(null);

  return (
    <React.Fragment>
      
      
      <div onClick={handleClickOutside} className={`chat-wrapper d-lg-flex gap-1 ${isFull ? 'full' : ''}`}>
      
        <div
         className="user-chat w-100 overflow-hidden border"
          ref={messageBox}
        >
          <div className="closefullscreen_wrap"> 
          <button onClick={handleAddClass} className="openfullscreen btn btn-secondary"><i class="ri-fullscreen-line"></i></button>
            <button onClick={handleRemoveClass} className="closefullscreen btn btn-secondary"><i class="ri-close-line"></i></button></div>
          
          {/* <div className="reload-chat">
                <Button onClick={reset_chat}  color="primary" className="refresh"><i className="ri-restart-line"></i></Button>
              </div>             */}
          <div className="chat-content d-lg-flex">
            <div className="w-100 overflow-hidden position-relative">
              <div className="position-relative">
                <div className="position-relative" id="users-chat">
                  <SimpleBar
                    className="chat-conversation p-3 p-lg-4"
                    id="chat-conversation"
                    scrollableNodeProps={{ ref: scrollableNodeRef }}
                  >
                    {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                    {/* <div id="elmLoader"></div> */}
                    <ul
                      className="list-unstyled chat-conversation-list"
                      id="users-conversation"
                    >
                     
                        {/* // Render History */}
                        { map(chat_history, (message, key) => (
                          <>
                          <li
                            className={
                              message.role === "user"
                                ? " chat-list right"
                                : "chat-list left"
                            }
                            key={key}
                          >
                            {/* {message.role === "user" && (
                              <div className="image_message">{
                                message?.image_inputs?.map((ele,key)=>{
                                    return <img key={key} src={ele.image_url.url} alt="User Image" className="img-fluid" />
                                })
                              }                                        
                              </div>                             
                            )} */}
                            {message.role === "user" && (
                              <div className="image_message">
                                {message?.image_inputs?.map((ele, key) => (
                                  <img
                                    key={key}
                                    src={ele.image_url.url}
                                    alt="User Image"
                                    className="img-fluid cursor-pointer rounded mb-2"
                                    style={{ maxWidth: "200px" }}
                                    onClick={() => setSelectedImage(ele.image_url.url)}
                                  />
                                ))}
                              </div>
                            )}
                            {message.role === "user" && message?.thread_file_inputs?.length > 0 && (
                              <div className="image_message">
                                  <FilePreview files={message?.thread_file_inputs} />
                              </div>
                            )}
                                   

                            <div className="conversation-list">
                              
                              {/* {message.sender === Chat_Box_Username && (
                                    <div className="chat-avatar">
                                      {Chat_Box_Image === undefined ?
                                        <img
                                          src={userDummayImage}
                                          alt=""
                                        />
                                        :
                                        <img
                                          src={Chat_Box_Image}
                                          alt=""
                                        />
                                      }
                                    </div>
                                  )} */}

                              <div className="user-chat-content">
                                <div className="ctext-wrap">
                                  <div className="ctext-wrap-content">
                                    <ButtonGroup>
                                      <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-primary">
                                            <i class="ri-more-2-line"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={()=>{
                                              Delete_Message(selectedthread , message.sequence_id)
                                            }} ><i class="ri-delete-bin-line"></i> Delete</DropdownItem>
                                            {/* <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem>Separated link</DropdownItem> */}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </ButtonGroup>
                                    <p className="mb-0 ctext-content markdown-table">
                                      <MarkdownRenderer
                                        markdown={Remove_Extra_Text(
                                          message?.message_content || ""
                                        )}
                                        bot_id={BotDetails.Bot_ID}
                                        className={"markdown-table"}
                                      />
                                       {/* {(message?.message_content?.includes("<table") ||
                                        message?.message_content?.includes("|")) && (
                                        <Button>
                                          <i className="ri-download-2-line"></i>
                                        </Button>
                                      )} */}
                                    </p>
                                    
                                   {
                                        ( message.formatted_data_for_visualization && Object.keys(message?.formatted_data_for_visualization).length > 0) ?
                                          <div className="view_full_chart" style={{ textAlign: 'right' }}>
                                            <Button
                                              id={`view_full_chart_button`}
                                              color="primary"
                                              onClick={() => {
                                                  setvisualization_modal(true)
                                                  setvisualization_modal_component(generate_Chart(message?.visualization, message?.formatted_data_for_visualization?.formatted_data_for_visualization))
                                              }}
                                            >
                                              <i className="ri-fullscreen-line"></i>
                                            </Button>
                                            <UncontrolledTooltip
                                              placement="left"
                                              target={`view_full_chart_button`}
                                              className="leftmore"
                                            >
                                              View chart full view
                                            </UncontrolledTooltip>
                                          </div> : " "
                                        
                                      }
                                    {
                                      (message?.formatted_data_for_visualization && !message?.formatted_data_for_visualization?.error )&& generate_Chart(message?.visualization, message?.formatted_data_for_visualization?.formatted_data_for_visualization)

                                    }                                    
                                    
                                    {/* { message.role === 'user' && <Chat_View_Item/>  }                           */}
                                    {message.role !== "user" && (
                                      <Mark_Favourite_modal
                                        group_id={BotDetails.Group_ID}
                                        Bot_ID={BotDetails.Bot_ID}
                                        visualization={message.visualization}
                                        formatted_data_for_visualization={message.formatted_data_for_visualization}
                                        Prompt_Question={
                                          message?.message_content || ""
                                        }
                                        query={message?.query}
                                        mongo_query={message?.mongo_query}
                                        assistant_id={BotDetails.Assets_ID}
                                        thread_id={selectedthread?.thread_id}
                                        model={BotDetails.Model}
                                      />
                                    )}
                                    <Button
                                      onClick={(e) => {
                                        // navigator.clipboard.writeText(message.content[0]?.text?.value || "");
                                        handleCkick(e.target);
                                      }}
                                      className="btn rounded-pill"
                                      color="primary"
                                      id="copymessage"
                                    >
                                      <i className="ri-file-copy-line"></i>
                                    </Button>
                                    <UncontrolledTooltip
                                      placement="left"
                                      target="copymessage"
                                      className="leftmore"
                                      id="copymessage"
                                    >
                                      Copy Message
                                    </UncontrolledTooltip>
                                    {message?.pandas_code_xml && message?.pandas_code_xml.trim().length > 0   && <PythonEditor_Modal code={message?.pandas_code_xml} />}
                                    {message.role !== "user" && (
                                      <>
                                      <Button
                                          onClick={() => {
                                            dispatch(THUMB_UP_MESSAGE({
                                              "Bot_Seq_Id": message.sequence_id,
                                              "Group_Id": BotDetails.Group_ID,
                                              "Thread_Id": selectedthread.thread_id,
                                              "User_Feedback": "UP"
                                            }));

                                            // Show and auto-hide the confirmation alert
                                            setLikeMessageVisible(true);
                                            setTimeout(() => {
                                              setLikeMessageVisible(false);
                                            }, 3000); // 3 seconds
                                          }}
                                          className="btn rounded-pill"
                                          color="primary"
                                          id="like"
                                        >
                                          <i className="ri-thumb-up-line"></i>
                                        </Button>
                                        <Thumb_Down_Reason_Modal Bot_Seq_Id={message.sequence_id} Group_Id={BotDetails.Group_ID} Thread_Id={selectedthread.thread_id}  />
                                        
                                      </>
                                    )}
                                    <Button
                                      onClick={() => {
                                        downloadText(
                                          message?.message_content || ""
                                        );
                                      }}
                                      className="btn rounded-pill"
                                      color="primary"
                                      id="downloadmessage"
                                    >
                                      <i className="ri-download-2-line"></i>
                                    </Button>
                                    <UncontrolledTooltip
                                      placement="left"
                                      target="downloadmessage"
                                      style={{ display: "block" }}
                                      id="downloadmessage"
                                    >
                                      Download Message
                                    </UncontrolledTooltip>
                                    {
                                    (message?.dbinsight_tokens && message?.dbinsight_tokens > 0) ?  (
                                      <span
                                        style={{
                                          fontWeight: "500",
                                          float: "right",
                                          color: "#f484ad",
                                        }}
                                      >
                                        Token used:
                                        {/* {message.dbinsight_tokens} */}
                                        {message.dbinsight_tokens.toFixed(2)}

                                      </span>
                                    ):" "}
                                    {(message?.query?.length > 0 ) && (
                                    <Chat_Sql_Modal
                                      show_sql_popup_query={
                                        message?.query
                                      }
                                      database_id={BotDetails.Database_ID} sql_query={message?.query}
                                    />
                                  )}
                                  {message?.query_description && <Query_Explanation explanation={message?.query_description} />}
                                  {( message?.mongo_query?.length > 0 )&& <Mongo_DB_Query_modal mongo_query={message?.mongo_query}  database_id={BotDetails.Database_ID} />}
                                  
                                  {/* {!paly_pause_toggle ? <Button onClick={()=>{
                                      handleSpeech(message?.message_content)
                                    }} className="btn rounded-pill"
                                    color="primary"> <i className="ri-play-mini-line"></i> </Button>
                                       :<Button onClick={()=>{
                                      stop_speech()
                                    }} className="btn rounded-pill"
                                    color="primary"><i className="ri-stop-circle-line"></i></Button>} */}

                                    <HandleSpeech_Button text={message?.message_content}   />
                                    {/* {message.role !== 'user' &&  <Chat_Sql_Modal /> } */}
                                    {message.role !== "user" && (
                                      <>{(message?.distance_map_data && JSON.stringify(message?.distance_map_data) != '{}' ) && <GoogleDistance distance_map_data={message?.distance_map_data} />}
                                        { (message?.places_map_data && JSON.stringify(message?.places_map_data) != '[]' && JSON.stringify(message?.places_map_data) != '{}')  &&  <GoogleMark places_map_data={message?.places_map_data} />} 
                                      </>
                                    )}
                                  </div>
                                 
                                  {/* <UncontrolledDropdown className="align-self-start message-box-drop">
                                        <DropdownToggle
                                          href="#"
                                          className="btn nav-btn"
                                          tag="a"
                                        >
                                          <i className="ri-more-2-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem href="#" className="reply-message" onClick={() => setreply(message)}>
                                            <i className="ri-reply-line me-2 text-muted align-bottom"></i>
                                            Reply
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-share-line me-2 text-muted align-bottom"></i>
                                            Forward
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={(e) => handleCkick(e.target)}>
                                            <i className="ri-file-copy-line me-2 text-muted align-bottom"></i>
                                            Copy
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-bookmark-line me-2 text-muted align-bottom"></i>
                                            Bookmark
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={() => dispatch(onDeleteMessage(message.id))}>
                                            <i className="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>
                                            Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown> */}
                                </div>
                                <div className="conversation-name">
                                  <small className="text-muted time">
                                    {convertISODateToUserLocal(
                                      message.created_at
                                    )}
                                    {/* { moment(message.created_at || "").format('YYYY-MM-DD hh:mm A' ) } */}
                                  </small>{" "}
                                  <span className="text-secondary check-message-icon">
                                    <i className="ri-check-double-line align-bottom"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </li>
                          { message.clear_context && <ClearContext />}
                          </>
                          ))
                        }
                      
                        {/* // Render current messages . */}
                       { map(current_message_list, (message, key) => (
                          <li
                            className={
                              message.role === "user"
                                ? " chat-list right"
                                : "chat-list left"
                            }
                            key={key}
                          >
                            {/* {message.role === "user" && (
                                            <div className="image_message">{
                                        message?.image_urls?.map((ele,key)=>{
                                            return <img key={key} src={ele} alt="User Image" className="img-fluid" />
                                        })
                                      }
                                        
                                      </div>
                                          )} */}
                             {message.role === "user" && (
                                <div className="image_message">
                                    <FilePreview files={message?.thread_file_inputs} 
                                     onImageClick={(url) => setSelectedImage(url)}
                                    />                                  
                                </div>
                                )}            

                            <div className="conversation-list">
                              <div className="user-chat-content">
                                <div className="ctext-wrap">
                                  <div className="ctext-wrap-content">
                                    <ButtonGroup>
                                      <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-primary">
                                            <i class="ri-more-2-line"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                             <DropdownItem onClick={()=>{
                                              Delete_Message(selectedthread , message.sequence_id)
                                            }} ><i class="ri-delete-bin-line"></i> Delete</DropdownItem>
                                            {/* <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem>Separated link</DropdownItem> */}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </ButtonGroup>
                                    <p className="mb-0 ctext-content markdown-table ">
                                      {(message.message !== undefined ||
                                        message.message === null ||
                                        message.message === "") && (
                                        <MarkdownRenderer
                                          markdown={Remove_Extra_Text(
                                            message.message
                                          )}
                                                   bot_id={BotDetails.Bot_ID}
                                        query_model={BotDetails.Query_Model}
                          
                                          className={"markdown-table"}
                                        />
                                      )}
                                       {
                                            ( message?.formatted_data_for_visualization && Object.keys(message.formatted_data_for_visualization).length > 0) ?
                                              <div className="view_full_chart" style={{ textAlign: 'right' }}>
                                                <Button
                                                  id={`view_full_chart_button`}
                                                  color="primary"
                                                  onClick={() => {
                                                  setvisualization_modal(true)
                                                  setvisualization_modal_component(generate_Chart(message?.visualization, message?.formatted_data_for_visualization?.formatted_data_for_visualization))
                                              }}
                                                >
                                                  <i className="ri-fullscreen-line"></i>
                                                </Button>
                                                <UncontrolledTooltip
                                                  placement="left"
                                                  target={`view_full_chart_button`}
                                                  className="leftmore"
                                                >
                                                  View chart full view
                                                </UncontrolledTooltip>
                                              </div> : " "
                                            
                                          }
                                      
                                          {
                                            (message?.formatted_data_for_visualization && !message?.formatted_data_for_visualization?.error) && generate_Chart(message?.visualization, message?.formatted_data_for_visualization?.formatted_data_for_visualization)
                                            
                                          }                                         
                                         
                                      
                                    </p>
                                    
                                    {message.role !== "user" && (
                                      <Mark_Favourite_modal
                                        visualization={message.visualization}
                                        formatted_data_for_visualization={message.formatted_data_for_visualization}
                                        group_id={BotDetails.Group_ID}
                                        Bot_ID={BotDetails.Bot_ID}
                                        Prompt_Question={message.message}
                                        query={message?.query}
                                        mongo_query={message?.mongo_query}
                                        assistant_id={BotDetails.Assets_ID}
                                        thread_id={selectedthread?.thread_id}
                                        model={BotDetails.Model}
                                      />
                                    )}
                                    <Button
                                      onClick={(e) => {
                                        // navigator.clipboard.writeText(message.message);
                                        handleCkick(e.target);
                                      }}
                                      className="btn rounded-pill"
                                      color="primary"
                                      id="copymessage"
                                    >
                                      <i className=" ri-file-copy-line"></i>
                                    </Button>
                                    <UncontrolledTooltip
                                      placement="left"
                                      target="copymessage"
                                      className="leftmore"
                                      id="copymessage"
                                    >
                                      Copy Message
                                    </UncontrolledTooltip>
                                    {message?.pandas_code_xml  && message?.pandas_code_xml.trim().length  && <PythonEditor_Modal code={message?.pandas_code_xml} />}
                                    
                                    {/* <Button
                                      className="btn rounded-pill"
                                      color="primary"
                                      id="like"
                                    >
                                     <i className="ri-thumb-up-line"></i> 
                                    </Button> */}
                                    <PythonEditor_Modal />
                                    
                                    {message.role !== "user" && (
                                        <>
                                        <Button
                                            onClick={() => {
                                              dispatch(THUMB_UP_MESSAGE({
                                                "Bot_Seq_Id": message.sequence_id,
                                                "Group_Id": BotDetails.Group_ID,
                                                "Thread_Id": selectedthread.thread_id,
                                                "User_Feedback": "UP"
                                              }));

                                              // Show and auto-hide the confirmation alert
                                              setLikeMessageVisible(true);
                                              setTimeout(() => {
                                                setLikeMessageVisible(false);
                                              }, 3000); // 3 seconds
                                            }}
                                            className="btn rounded-pill"
                                            color="primary"
                                            id="like"
                                          >
                                            <i className="ri-thumb-up-line"></i>
                                          </Button>
                                          <Thumb_Down_Reason_Modal Bot_Seq_Id={message.sequence_id} Group_Id={BotDetails.Group_ID} Thread_Id={selectedthread.thread_id} />
                                          
                                        </>
                                      )}
                                    <Button
                                      onClick={() => {
                                        downloadText(message.message);
                                      }}
                                      className="btn rounded-pill"
                                      color="primary"
                                    >
                                      <i className="ri-download-2-line"></i>
                                    </Button>
                                    {
                                    (message?.dbinsight_tokens && message?.dbinsight_tokens > 0) ?  (
                                      <span
                                        style={{
                                          fontWeight: "500",
                                          float: "right",
                                          color: "#f484ad",
                                        }}
                                      >
                                        Token used:
                                        {/* {message.dbinsight_tokens} */}
                                         {message.dbinsight_tokens.toFixed()}
                                      </span>
                                    ): " "}
                                    {message?.query?.length > 0 && (
                                    <Chat_Sql_Modal
                                      show_sql_popup_query={
                                        message?.query
                                      }
                                      database_id={BotDetails.Database_ID} sql_query={message?.query}
                                    />
                                  )}
                                  { message?.query_description && <Query_Explanation explanation={message?.query_description} />}
                                  
                                     {( message?.mongo_query?.length > 0 )&& <Mongo_DB_Query_modal mongo_query={message?.mongo_query}  database_id={BotDetails.Database_ID} />}
                                     {/* <Button onClick={()=>{
                                      handleSpeech(message.message)
                                    }} 
                                    className="btn rounded-pill"
                                      color="primary"
                                    ><i className="ri-play-mini-line"></i></Button>
                                     <Button onClick={()=>{
                                      stop_speech()
                                    }} className="btn rounded-pill"
                                    color="primary"> <i className="ri-stop-circle-line"></i></Button> */}
                                    <HandleSpeech_Button text={message.message}  />
                                    
                                    {/* <span style={{fontWeight: '500', float: 'right', color: '#f484ad'}}>token used {'(2000)'}</span> */}                                   
                                    {message.role !== "user" && (
                                      <>
                                        <>{(message?.distance_map_data && JSON.stringify(message?.distance_map_data) != '{}' ) && <GoogleDistance distance_map_data={message?.distance_map_data} />}
                                        { (message?.places_map_data && JSON.stringify(message?.places_map_data) != '[]' && JSON.stringify(message?.places_map_data) != '{}')  &&  <GoogleMark places_map_data={message?.places_map_data} />} 
                                      </>
                                      </>
                                    )}
                                  </div>
                                  {/* <UncontrolledDropdown className="align-self-start message-box-drop">
                                        <DropdownToggle
                                          href="#"
                                          className="btn nav-btn"
                                          tag="a"
                                        >
                                          <i className="ri-more-2-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem href="#" className="reply-message" onClick={() => setreply(message)}>
                                            <i className="ri-reply-line me-2 text-muted align-bottom"></i>
                                            Reply
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-share-line me-2 text-muted align-bottom"></i>
                                            Forward
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={(e) => handleCkick(e.target)}>
                                            <i className="ri-file-copy-line me-2 text-muted align-bottom"></i>
                                            Copy
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-bookmark-line me-2 text-muted align-bottom"></i>
                                            Bookmark
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={() => dispatch(onDeleteMessage(message.id))}>
                                            <i className="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>
                                            Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown> */}
                                </div>
                                <div className="conversation-name">
                                  <small className="text-muted time">
                                    {convertISODateToUserLocal(
                                      message.timeStamp
                                    )}
                                    {/* { moment(message.timeStamp).format('YYYY-MM-DD hh:mm A') } */}
                                  </small>{" "}
                                  <span className="text-success check-message-icon">
                                    <i className="ri-check-double-line align-bottom"></i>
                                  </span>
                                </div>
                              </div>
                            </div>                            
                          </li>
                          
                          ))
                        }

                      {/* // Message streaming . */}
                      {streaming_message !== "" && (
                        <li className={"chat-list left"}>
                          <div className="conversation-list">
                            <div className="user-chat-content">
                              <div className="ctext-wrap">
                                <div className="ctext-wrap-content">
                                <ButtonGroup>
                                      <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-primary">
                                            <i class="ri-more-2-line"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem  onClick={()=>{
                                              Delete_Message(selectedthread , ask_bot_response.bot_sequence_id)
                                            }} ><i class="ri-delete-bin-line"></i> Delete</DropdownItem>
                                            {/* <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem>Separated link</DropdownItem> */}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </ButtonGroup>
                                  
                                  <p className="mb-0 ctext-content markdown-table">
                                    {
                                      <MarkdownRenderer
                                        markdown={Remove_Extra_Text(
                                          streaming_message
                                        )}
                                                 bot_id={BotDetails.Bot_ID}
              
                                        className={"markdown-table"}
                           
                                      />                                      
                                      
                                    }
                                  
                                   {
                                        ( ask_bot_response?.formatted_data_for_visualization && Object.keys(ask_bot_response?.formatted_data_for_visualization).length > 0) ?
                                          <div className="view_full_chart" style={{ textAlign: 'right' }}>
                                            <Button
                                              id={`view_full_chart_button`}
                                              color="primary"
                                              onClick={() => {
                                                  setvisualization_modal(true)
                                                  setvisualization_modal_component(generate_Chart(ask_bot_response?.visualization, ask_bot_response?.formatted_data_for_visualization?.formatted_data_for_visualization))
                                              }}
                                            >
                                              <i className="ri-fullscreen-line"></i>
                                            </Button>
                                            <UncontrolledTooltip
                                              placement="left"
                                              target={`view_full_chart_button`}
                                              className="leftmore"
                                            >
                                              View chart full view
                                            </UncontrolledTooltip>
                                          </div> : " "
                                        
                                      } 
                                    {
                                      (ask_bot_response?.formatted_data_for_visualization && !ask_bot_response?.formatted_data_for_visualization?.error ) && generate_Chart(ask_bot_response?.visualization, ask_bot_response?.formatted_data_for_visualization?.formatted_data_for_visualization)
                                      
                                    }  

                                                                    
                                  
                                  </p>
                                  
                                  {
                                    <Mark_Favourite_modal
                                      visualization={ask_bot_response?.visualization}
                                      formatted_data_for_visualization={ask_bot_response?.formatted_data_for_visualization}
                                      group_id={BotDetails.Group_ID}
                                      Bot_ID={BotDetails.Bot_ID}
                                      Prompt_Question={streaming_message}
                                      assistant_id={BotDetails.Assets_ID}
                                      thread_id={selectedthread?.thread_id}
                                      model={BotDetails.Model}
                                      query={ask_bot_response?.query}
                                      mongo_query={ask_bot_response?.mongo_query}
                                    />
                                  }
                                  <Button
                                    onClick={(e) => {
                                      // navigator.clipboard.writeText(streaming_message);
                                      handleCkick(e.target);
                                    }}
                                    className="btn rounded-pill"
                                    color="primary"
                                    id="copymessage"
                                  >
                                    <i className=" ri-file-copy-line"></i>
                                  </Button>
                                  
                                  <UncontrolledTooltip
                                      placement="left"
                                      target="copymessage"
                                      className="leftmore"
                                      id="copymessage"
                                    >
                                      Copy Message
                                    </UncontrolledTooltip>
                                    {ask_bot_response?.pandas_code_xml  && ask_bot_response?.pandas_code_xml.trim().length > 0 && <PythonEditor_Modal code={ask_bot_response?.pandas_code_xml} />}

                                    {/* <Button
                                      className="btn rounded-pill"
                                      color="primary"
                                      id="like"
                                      onClick={()=>{
                                               dispatch(THUMB_UP_MESSAGE({
                                              "Bot_Seq_Id": ask_bot_response.bot_sequence_id,
                                              "Group_Id": BotDetails.Group_ID,
                                              "Thread_Id": selectedthread.thread_id,
                                              
                                              "User_Feedback": "UP"

                                          }))
                                      }}
                                    >
                                      <i className="ri-thumb-up-line"></i>
                                    </Button>
                                    <Thumb_Down_Reason_Modal Bot_Seq_Id={ask_bot_response.bot_sequence_id} Group_Id={BotDetails.Group_ID} Thread_Id={selectedthread.thread_id}  /> */}
                                    {(Boolean(!ask_bot_loading) &&
                                    (ask_bot_response?.DbInsightTokens && ask_bot_response?.DbInsightTokens > 0)) && (
                                      <>                                       

                                        {/* <Button
                                          className="btn rounded-pill"
                                          color="primary"
                                          id="like"
                                          onClick={() => {
                                            dispatch(THUMB_UP_MESSAGE({
                                              "Bot_Seq_Id": ask_bot_response.bot_sequence_id,
                                              "Group_Id": BotDetails.Group_ID,
                                              "Thread_Id": selectedthread.thread_id,
                                              "User_Feedback": "UP"
                                            }))
                                          }}
                                        >
                                          <i className="ri-thumb-up-line"></i>
                                        </Button> */}
                                        <Button
                                            className="btn rounded-pill"
                                            color="primary"
                                            id="like"
                                            onClick={() => {
                                              dispatch(THUMB_UP_MESSAGE({
                                                "Bot_Seq_Id": ask_bot_response.bot_sequence_id,
                                                "Group_Id": BotDetails.Group_ID,
                                                "Thread_Id": selectedthread.thread_id,
                                                "User_Feedback": "UP"
                                              }));

                                              setLikeMessageVisible(true);
                                              setTimeout(() => {
                                                setLikeMessageVisible(false);
                                              }, 3000); // 3 seconds
                                            }}
                                          >
                                            <i className="ri-thumb-up-line"></i>
                                          </Button>
                                        

                                        <Thumb_Down_Reason_Modal
                                          Bot_Seq_Id={ask_bot_response.bot_sequence_id}
                                          Group_Id={BotDetails.Group_ID}
                                          Thread_Id={selectedthread.thread_id}
                                        />
                                      </>
                                  )}
                                    
                                  <Button
                                    onClick={() => {
                                      downloadText(streaming_message);
                                    }}
                                    className="btn rounded-pill"
                                    color="primary"
                                  >
                                    <i className="  ri-download-2-line"></i>
                                  </Button>                                  
                                  {(Boolean(!ask_bot_loading) &&
                                    (ask_bot_response?.DbInsightTokens && ask_bot_response?.DbInsightTokens > 0)) ?  (
                                      <span
                                        style={{
                                          fontWeight: "500",
                                          float: "right",
                                          color: "#f484ad",
                                        }}
                                      >
                                        Token used:
                                        {ask_bot_response.DbInsightTokens?.toFixed(2)}
                                      </span>
                                    ):""}
                                    
                                  {ask_bot_response?.query?.length > 0 && (
                                    <Chat_Sql_Modal
                                      show_sql_popup_query={
                                        ask_bot_response?.query
                                      }
                                      database_id={BotDetails.Database_ID} sql_query={ask_bot_response?.query}
                                    />
                                  )}
                                  
                                   {( ask_bot_response?.mongo_query?.length > 0 )&& <Mongo_DB_Query_modal mongo_query={ask_bot_response?.mongo_query}  database_id={BotDetails.Database_ID} />}
                                   
                                   {ask_bot_response?.query_description && <Query_Explanation explanation={ask_bot_response?.query_description} />}
                                    {Boolean(!ask_bot_loading) && <HandleSpeech_Button text={streaming_message}   />}
                                   {/* {Boolean(!ask_bot_loading) &&<Button onClick={()=>{
                                      stop_speech()
                                    }} > <i className="ri-stop-circle-line"></i></Button>} */}
                                    
                                    <>{(ask_bot_response?.Distance_Map_Data && JSON.stringify(ask_bot_response?.Distance_Map_Data) != '{}' ) && <GoogleDistance distance_map_data={ask_bot_response?.Distance_Map_Data} />}
                                        { (ask_bot_response?.Places_Map_Data && JSON.stringify(ask_bot_response?.Places_Map_Data) != '[]' && JSON.stringify(ask_bot_response?.Places_Map_Data) != '{}')  &&  <GoogleMark places_map_data={ask_bot_response?.Places_Map_Data} />} 
                                      </>
                                        {/* <GoogleMark />
                                        <GoogleDistance /> */}
                                      
                                    
                               {Boolean(ask_bot_loading) && <span className="right_me">Loading <Spinner color="primary" type="grow" className="msg_remain"> Loading... </Spinner></span>}
                                </div>
                                {/* <UncontrolledDropdown className="align-self-start message-box-drop">
                                       <DropdownToggle
                                         href="#"
                                         className="btn nav-btn"
                                         tag="a"
                                       >
                                         <i className="ri-more-2-fill"></i>
                                       </DropdownToggle>
                                       <DropdownMenu>
                                         <DropdownItem href="#" className="reply-message" onClick={() => setreply(streaming_message)}>
                                           <i className="ri-reply-line me-2 text-muted align-bottom"></i>
                                           Reply
                                         </DropdownItem>
                                         <DropdownItem href="#">
                                           <i className="ri-share-line me-2 text-muted align-bottom"></i>
                                           Forward
                                         </DropdownItem>
                                         <DropdownItem href="#" onClick={(e) => handleCkick(e.target)}>
                                           <i className="ri-file-copy-line me-2 text-muted align-bottom"></i>
                                           Copy
                                         </DropdownItem>
                                         <DropdownItem href="#">
                                           <i className="ri-bookmark-line me-2 text-muted align-bottom"></i>
                                           Bookmark
                                         </DropdownItem>
                                         {/* <DropdownItem href="#" onClick={() => dispatch(onDeleteMessage(message.id))}>
                                           <i className="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>
                                           Delete
                                         </DropdownItem> 
                                       </DropdownMenu>
                                     </UncontrolledDropdown> */}
                                     
                              </div>
                              <div className="conversation-name">
                                <small className="text-muted time">
                                  {!ask_bot_loading &&  moment(streaming_message_time).format(
                                    "dddd, MMMM D, YYYY h:mm A "
                                  )}
                                </small>{" "}
                                <span className="text-success check-message-icon">
                                  <i className="ri-check-double-line align-bottom"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      
                    </ul>
                    <ImageModal
                      imageUrl={selectedImage}
                      onClose={() => setSelectedImage(null)}
                    />
                    {typingloader && <TypingLoader_cust />}
                  </SimpleBar>
                  {likeMessageVisible && (
                    <div
                      className="alert alert-success alert-dismissible likemessage-alert px-4 fade show"
                      id="likemessage"
                      role="alert"
                    >
                      Your response is stored
                    </div>
                  )}
                  <div
                    className="alert alert-warning alert-dismissible copyclipboard-alert px-4 fade show "
                    id="copyClipBoard"
                    role="alert"
                  >
                    Message copied
                  </div>
                  {emojiPicker && (
                    <div className="alert pickerEmoji">
                      <Picker
                        disableSearchBar={true}
                        onEmojiClick={onEmojiClick}
                      />
                    </div>
                  )}
                </div>

                <div className="chat-input-section p-3 p-lg-4 bg-transparent">
                  <span class="text-muted status_show">{Boolean(ask_bot_loading) && <><small>Status:</small> <span>{event_state}</span></>}</span>
                  <div className="chat-text-area">
                  <form id="input_node-form">
                    
                    <Row className="g-0">
                      {        User_Role!=='Viewer'   &&  <div className="col">
                        <div className="text_area_input">
                        {/* <div className="files-holder">
                              <div className="file-inner-wrp">
                                <i className="ri-file-line"></i>
                              </div>
                            </div>  */}
                        <Chat_File_Upload_Item
                          files={files}
                          setfiles={setfiles}
                        />
                        <div className="chat-input-feedback">
                          Please Enter a Message
                        </div>
                        {User_Role !== 'Viewer' && 
                        // <input
                        //   type="text"
                        //   disabled={listening}
                        //   value={asked_message}
                        //   onKeyDown={onKeyPress}
                        //   onChange={(e) => setasked_message(e.target.value)}
                        //   className="form-control chat-input bg-light border-light"
                        //   id="chat-input"
                        //   placeholder={listening ? "Listening ...":"Type your message..."}
                        // />
                        <textarea
                          rows="1"
                          type="text"
                          disabled={listening}
                          value={asked_message}
                          ref={textareaRef}
                          onKeyDown={onKeyPress}
                          onChange={(e) => setasked_message(e.target.value)}
                          onFocus={() => setIsFocused(true)}   
                          onBlur={() => setIsFocused(false)}
                          onInput={adjustHeight}  // Dynamically adjust height when content changes
                          className="form-control chat-input"
                          id="chat-input"
                          placeholder={listening ? "Listening ..." : "Type your message..."}
                          style={{
                            overflowY: 'auto',
                            maxHeight: '150px',  
                            resize: 'none', 
                            // position: 'absolute',  
                            // top: '-36px',  
                          }}
                        >
                        </textarea>
                        }
                        </div>
                      </div>}
                    </Row>
                    <Row className="g-0 justify-content-between align-items-center">
                     {/* <div className="col-auto">
                        <div className="chat-input-links me-2 pr-t3">
                           <div className="links-list-item">
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none emoji-btn"
                                  id="emoji-btn"
                                  onClick={() => setemojiPicker(!emojiPicker)}
                                >
                                  <i className="bx bx-smile align-middle"></i>
                                </button>
                              </div> 
                        </div>
                      </div>*/}
                      {User_Role!=='Viewer'&& <div className="mobile_float col-auto">
                        {/* <i ref={buttonRef} className="ri-more-2-line"></i> */}
                        <div ref={floatContentRef} className={`float_content ${isActive ? "active" : ""}`}>
                          <div className="col-auto">
                            <div className="chat-input-links mr-2 pr-t3">
                              {User_Role!=='Viewer' && <div className="links-list-item">
                                {/* <ChatFileUploadModal />                             */}
                                <Button
                                  type="button"
                                  onClick={handleClick}
                                  className="chat-send waves-effect no-style-button"
                                  id="addfile"
                                >
                                  <i className=" ri-add-line align-bottom"></i>
                                  <span className="d-flex align-items-center custom_spin"></span>
                                  <input
                                    type="file"
                                    multiple={true}
                                    style={{ display: "none" }}
                                    onChange={handleChange}
                                     accept={
                                       allowed_images
                                         ? ".jpg, .jpeg, .png, .gif, .bmp, .tiff, .pdf, .doc, .docx, .txt, .csv "
                                         : ".pdf, .doc, .docx, .txt, .csv"
                                     }
                                    ref={hiddenFileInput}
                                  />
                                </Button>
                                <UncontrolledTooltip
                                  placement="left"
                                  target="addfile" 
                                  id="Addfile"
                                >
                                  {" "}
                                  Add File{" "}
                                </UncontrolledTooltip>
                              </div>} 
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="chat-input-links mr-2">
                            <Button
                                  type="button"
                                  color=""
                                  className={`chat-send waves-effect ${isActiveWeb ? "webactive" : ""}`}
                                  id="webserwer"
                                  onClick={handleClick_button}
                                >
                                  <i className="bx bx-globe" id="globe"></i>
                                  <UncontrolledTooltip
                                  placement="left"
                                  target="webserwer" 
                                  id="Addfile"
                                >
                                {config.tool_tip.globe_icon}
                                </UncontrolledTooltip>
                            </Button>                           
                             
                            </div>
                          </div>
                          <div className="col-auto" style={{ position: "relative"}}>
                            {BotDetails.Type !== "DBLink"&&<Button
                             ref={buttonToolRef} 
                             onClick={toggleTool}
                             className={`settings-btn ${isshowTool ? "active" : ""}`}
                            style={{
                              backgroundColor:'transparent', 
                              border:'none'
                            }}>
                                <i class="ri-tools-line"></i>
                              </Button>}
                               {isshowTool && (
                                    <div ref={toolRef} className="chat-tool-container">
                                      <Chat_Tool isActiveWeb={isActiveWeb} handleClick_button={handleClick_button}  />
                                    </div>
                                  )}
                          </div>
                        </div>
                      </div>}
                       <div className="col-auto">
                        <Row className="sclv">
                          <div className="col-auto">
                              {/* <ButtonGroup className="language-select">
                                  <UncontrolledDropdown direction="up">
                                      <DropdownToggle onClick={(e)=>{
                                        e.preventDefault()
                                      }} tag="button" className="btn btn-light">
                                          <i className="ri-translate-2"></i><i className="mdi mdi-chevron-down"></i>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                          <DropdownItem>English</DropdownItem>
                                          <DropdownItem>Chinees</DropdownItem>
                                          <DropdownItem>Traditional chinese</DropdownItem>
                                      </DropdownMenu>
                                  </UncontrolledDropdown>
                              </ButtonGroup> */}
                              {User_Role!=='Viewer'&& <ButtonGroup className="language-select" id="lang">
                                <UncontrolledDropdown direction="up">
                                  <DropdownToggle
                                    onClick={(e) => e.preventDefault()}
                                    tag="button"
                                    className="btn"
                                  >
                                    <span style={{fontSize:'22px'}}>{selected_language_lable}</span>
                                    <i className="mdi mdi-chevron-down"></i>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem onClick={() => {handleLanguageSelect('English')
                                      setselected_language_lable('EN')
                                    }}>English</DropdownItem>
                                    <DropdownItem onClick={() => {handleLanguageSelect('Simplified Chinese')
                                          setselected_language_lable('SC')
                                    }}> Simplified Chinese</DropdownItem>
                                    <DropdownItem onClick={() => {handleLanguageSelect('Traditional Chinese')
                                      setselected_language_lable('TC')
                                    }}>Traditional Chinese</DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </ButtonGroup>} 
                              {User_Role!=='Viewer'&&<UncontrolledTooltip
                                      placement="left"
                                      target="lang" 
                                      id="tran"
                                    >
                                      {config.tool_tip.language_icon}
                              </UncontrolledTooltip>}
                          </div>                        
                          <div className="col-auto">
        
                              {/* <Button type="button"
                          onPointerDown={(e) => {
                            e.preventDefault();
                            if (SpeechRecognition && typeof SpeechRecognition.startListening === "function") {
                              try {
                                SpeechRecognition.startListening();
                              } catch (err) {
                                console.error("Error starting speech recognition:", err);
                              }
                            } else {
                              console.error("SpeechRecognition is not supported on this browser.");
                            }
                          }}
                          onPointerUp={(e) => {
                            e.preventDefault();
                            if (SpeechRecognition && typeof SpeechRecognition.stopListening === "function") {
                              try {
                                SpeechRecognition.stopListening();
                              } catch (err) {
                                console.error("Error stopping speech recognition:", err);
                              }
                            }
                          }}
                        >
                          Hold to talk
                        </Button> */}

                        {/* orignal code */}

                            { User_Role!=='Viewer' && Boolean(!ask_bot_loading)  && (  transcriptions_loading ? <span className="mike_loader"><Loader/></span> :  !recording ? <Button id="mic" onClick={()=>{
                                // e.preventDefault();
                                // resetTranscript()
                                // SpeechRecognition.startListening({ continuous: true })
                                startRecording();
                              }
                              }
                              className="mr-2 pr-t3"
                              style={{}}
                              ><i className="ri-mic-line"></i></Button>
                              :
                              User_Role!=='Viewer' && <Button id="mic" onClick={

                                (e)=>{
                                  //    e.preventDefault()
                                  // SpeechRecognition.stopListening()
                                  stopRecording();
                                }
                                
                                
                                } className="mr-2" style={{padding: "2px 9px"}}><i className="ri-mic-off-line"></i></Button>)
                        }
                        {User_Role!=='Viewer'&& <UncontrolledTooltip placement="top" target="mic" id="speach">{config.tool_tip.mic_icon}</UncontrolledTooltip>}
                        {/* testing code */}


                              {/* <button onClick={(e)=>{
                                e.preventDefault()
                                resetTranscript()
                              }
                                
                              }>Reset</button> */}
                              {/* <p>{transcript}</p> */}
                              
                          </div>
                          {User_Role!=='Viewer'&& <div className="col-auto">
                            <div className="chat-input-links pr-t3">
                              <div className="links-list-item">
                                
                              <Button
                                  type="button"
                                  color=""                                  
                                  className="chat-send waves-effect"
                                  onClick={clear_context}
                                  id="clear"
                                >
                              <i className="ri-eraser-line align-bottom"></i>
                                <span className="d-flex align-items-center custom_spin">                              
                                
                              </span>
                                </Button>
                                <div
                                  className="alert alert-success alert-dismissible clear-alert px-4"
                                  id="clear_alert"
                                  role="alert"
                                >
                                Clearing Context
                                </div>
                                <UncontrolledTooltip placement="top" target="clear" id="clear">{config.tool_tip.clear}</UncontrolledTooltip>
                              </div>
                            </div>
                          </div>}
                          <div className="col-auto">
                            { User_Role!=='Viewer' && <div className="chat-input-links ms-2 mr-2 pr-t3">
                              <div className="links-list-item">
                                {Boolean(!ask_bot_loading) ? (
                                  <Button
                                    type="button"
                                    color=""
                                    onClick={() => {
                                      resetTextareaHeight()
                                      onAsk_message(asked_message);
                                      
                                    }}
                                    className={`chat-send waves-effect ${isFocused ? "active" : "inactive"}`}
                                    id="Send"
                                  >
                                    <i className="ri-send-plane-2-line align-bottom"></i>
                                    <span className="d-flex align-items-center custom_spin"></span>
                                  </Button>
                                ) : (
                                  // run_id && (
                                  //   <Button
                                  //     type="button"
                                  //     color=""
                                  //     className="chat-send waves-effect"
                                  //     onClick={() => {
                                  //       dispatch(
                                  //         Bot_Chat_Cancel({
                                  //           thread_id: selectedthread?.thread_id,
                                  //           run_id,
                                  //         })
                                  //       );
                                  //     }}
                                  //   >
                                  //     <>
                                  //       <span className="d-flex align-items-center custom_spin">
                                  //         <Spinner
                                  //           size="sm"
                                  //           className="flex-shrink-0"
                                  //         >
                                  //           {" "}
                                  //           Loading...{" "}
                                  //         </Spinner>
                                  //         <span className="">
                                  //           <i className=" ri-close-circle-line"></i>
                                  //         </span>
                                  //       </span>
                                  //     </>
                                  //   </Button>
                                  // )
                                  (
                                    <Button
                                    onClick={() => {
                                         dispatch(
                                         Bot_Chat_Cancel({
                                            thread_id: selectedthread?.thread_id,
                                          })
                                       );
                                       }}
                                    ><i class="ri-stop-circle-fill"></i></Button>
                                  )
                                )}
                                {/* <button
                                  onClick={startRecording}
                                  disabled={recording}
                                >
                                  Start Recording
                                </button>
                                <button
                                  onClick={stopRecording}
                                  disabled={!recording}
                                >
                                  Stop Recording
                                </button>
                                {audioURL && (
                                  <div>
                                    <h3>Playback:</h3>
                                    <audio controls src={audioURL}></audio>
                                  </div>
                                )} */}
                                {Boolean(!ask_bot_loading) && <UncontrolledTooltip id="Send Message" placement="left" target="Send">
                                  {" "}
                                  Send Message{" "}
                                </UncontrolledTooltip>}
                              </div>
                            </div>}
                          </div>
                        </Row>
                      </div>    
                    </Row>
                  </form>
                  </div>
                </div>

                {User_Role!=='Viewer'&& <div className={reply ? "replyCard show" : "replyCard"}>
                  <Card className="mb-0 card-bg-fill card-border-effect-none">
                    <CardBody className="py-3">
                      <div className="replymessage-block mb-0 d-flex align-items-start">
                        <div className="flex-grow-1">
                          <h5 className="conversation-name">
                            {reply && reply.sender}
                          </h5>
                          <p className="mb-0">{reply && reply.message}</p>
                        </div>
                        <div className="flex-shrink-0">
                          <button
                            type="button"
                            id="close_toggle"
                            className="btn btn-sm btn-link mt-n2 me-n3 fs-18"
                            onClick={() => setreply("")}
                          >
                            <i className="bx bx-x align-middle"></i>
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      <PersonalInfo
        show={isInfoDetails}
        onCloseClick={() => setIsInfoDetails(false)}
        currentuser={Chat_Box_Username}
        cuurentiseImg={Chat_Box_Image}
      />

      <Modal
        isOpen={visualization_modal}
        toggle={() => {
          setvisualization_modal(!visualization_modal)
        }}
        size="xxl"
      >
          <ModalHeader className="modal-title"
              id="myModalLabel" toggle={() => {
          setvisualization_modal(!visualization_modal)
        }}>
          </ModalHeader>
          <ModalBody>
              {visualization_modal_component}
          </ModalBody>
          
      </Modal>
    </React.Fragment>
  );
};

export default Chat;